/* Duration */
export const formatStringDuration = (minutes: number, seconds: number) => {
  const minString = minutes < 10 ? `0${minutes}` : minutes
  const secString = seconds < 10 ? `0${seconds}` : seconds
  return `${minString}:${secString}`
}

export const durationOnBlurInterceptor = (e: Record<string, unknown>) => {
  const {
    target: { value },
  } = e
  if (!value.includes(':')) {
    const minutes = Math.floor(value / 60)
    const seconds = value % 60
    return formatStringDuration(minutes, seconds)
  }
  const [minutes, seconds] = value.split(':')
  const extraMinutes = Math.floor(+seconds / 60)
  const totMinutes = +minutes + extraMinutes
  const totSeconds = +seconds % 60
  return formatStringDuration(Math.min(totMinutes, 59), Math.min(+totSeconds, 59))
}

export const matchPatternInterceptor = (pattern: string) => (e: Record<string, unknown>) => {
  const {
    target: { value },
  } = e
  if (!value.length) {
    return e
  }
  const splitValues = value.split('').reverse()
  const splitPattern = pattern.split('')
  const formattedInput = splitPattern
    .reduce((agg, char, index) => {
      if (char === 'x') {
        const val = splitValues.pop()
        if (!isNaN(val)) {
          return [...agg, val]
        } else {
          return agg
        }
      }
      if (value.length > index) {
        if (splitValues[splitValues.length - 1] === char) {
          splitValues.pop()
        }
        return [...agg, char]
      }
      return agg
    }, [])
    .join('')
  return formattedInput
}

/* Ipi number */
export const ipiNumberOnChangeInterceptor = (e: Record<string, unknown>) => {
  const {
    target: { value },
  } = e
  if (!value.length) {
    return e
  }
  return +value.slice(0, 11)
}

/*  NOTE(Kitti): Pattern matching 
    x: number
    y: letter (not yet implemented)
    z: number or letter (not yet implemented)
*/
export const getInterceptors = (interceptorKey: string) => {
  switch (interceptorKey) {
    case 'duration':
      return {
        onChangeInterceptor: matchPatternInterceptor('xx:xx'),
        onBlurInterceptor: durationOnBlurInterceptor,
      }

    case 'ipiNumber':
      return { onChangeInterceptor: ipiNumberOnChangeInterceptor }
    default:
      return {}
  }
}
